import {useState,useEffect} from 'react';
import api from '../../../services/api';
import {PEDIDO_VAZIO,ITEM_VAZIO,CANAL_PRECO} from '../constants';
import {calcTotais} from '../utils';

export function useVendas(){
  const [pedidos,setPedidos]=useState([]);
  const [clientes,setClientes]=useState([]);
  const [produtos,setProdutos]=useState([]);
  const [loading,setLoading]=useState(true);
  const [salvando,setSalvando]=useState(false);
  const [modalForm,setModalForm]=useState(null);
  const [form,setForm]=useState(PEDIDO_VAZIO);
  const [itens,setItens]=useState([]);
  const [modalRetirada,setModalRetirada]=useState(null);

  const carregar=async()=>{
    setLoading(true);
    try{
      const [pR,cR]=await Promise.all([
        api.get('/vendas/pedidos/?page_size=1000'),
        api.get('/clientes/contatos/?page_size=1000'),
      ]);
      setPedidos(pR.data.results||pR.data);
      setClientes((cR.data.results||cR.data).filter(c=>c.tipo!=='FORNECEDOR'));
    }finally{setLoading(false);}
  };

  const carregarProdutos=async()=>{
    if(produtos.length>0)return;
    const r=await api.get('/produtos/produtos/?page_size=1000');
    setProdutos(r.data.results||r.data);
  };

  useEffect(()=>{carregar();},[]);

  const setF=(f,v)=>setForm(p=>({...p,[f]:v}));
  const atualizarTotais=(its,d,s)=>{const t=calcTotais(its,d,s);setForm(f=>({...f,...t}));};
  const addItem=()=>setItens(p=>[...p,{...ITEM_VAZIO}]);
  const removeItem=(idx)=>{const n=itens.filter((_,i)=>i!==idx);setItens(n);atualizarTotais(n,form.desconto,form.valor_servico);};
  const setItem=(idx,field,val)=>{
    setItens(prev=>{
      const n=[...prev];
      n[idx]={...n[idx],[field]:val};
      if(['quantidade','preco_unit'].includes(field)){
        const q=parseFloat(field==='quantidade'?val:n[idx].quantidade||0);
        const p=parseFloat(field==='preco_unit'?val:n[idx].preco_unit||0);
        n[idx].valor_total=(q*p).toFixed(2);
      }
      atualizarTotais(n,form.desconto,form.valor_servico);
      return n;
    });
  };
  const selectProduto=(idx,prodId)=>{
    const prod=produtos.find(x=>x.id===parseInt(prodId));
    if(!prod)return;
    const tp=(prod.tabela_precos||[]).find(x=>x.tipo_cliente===(CANAL_PRECO[form.canal]||''));
    const preco=tp?parseFloat(tp.preco_final):parseFloat(prod.preco_custo);
    setItens(prev=>{
      const n=[...prev];
      n[idx]={...n[idx],produto:prodId,preco_unit:preco.toFixed(4),valor_total:(parseFloat(n[idx].quantidade||1)*preco).toFixed(2)};
      atualizarTotais(n,form.desconto,form.valor_servico);
      return n;
    });
  };

  const abrirNovo=async()=>{
    await carregarProdutos();
    setForm({...PEDIDO_VAZIO,data_pedido:new Date().toISOString().slice(0,10)});
    setItens([]);
    setModalForm('novo');
  };

  const abrirEditar=async(pedido)=>{
    await carregarProdutos();
    setItens([]);
    setForm({...pedido,cliente:String(pedido.cliente)});
    const res=await api.get('/vendas/itens/?pedido='+pedido.id);
    setItens((res.data.results||res.data).map(i=>({...i,produto:String(i.produto)})));
    setModalForm('editar');
  };

  const fecharModal=()=>setModalForm(null);

  const salvar=async()=>{
    if(!form.cliente){alert('Selecione o cliente.');return;}
    if(!itens.filter(i=>i.produto).length){alert('Adicione pelo menos um produto.');return;}
    setSalvando(true);
    try{
      const dp={...form,cliente:parseInt(form.cliente),prazo_previsto:form.prazo_previsto||null};
      let pedido;
      if(modalForm==='novo'){const r=await api.post('/vendas/pedidos/',dp);pedido=r.data;}
      else{const r=await api.put('/vendas/pedidos/'+form.id+'/',dp);pedido=r.data;const old=await api.get('/vendas/itens/?pedido='+pedido.id);for(const it of(old.data.results||old.data))await api.delete('/vendas/itens/'+it.id+'/');}
      for(const it of itens.filter(i=>i.produto))await api.post('/vendas/itens/',{...it,pedido:pedido.id});
      carregar();fecharModal();
    }catch{alert('Erro ao salvar.');}
    finally{setSalvando(false);}
  };

  const excluir=async(id)=>{
    if(!window.confirm('Excluir pedido?'))return;
    await api.delete('/vendas/pedidos/'+id+'/');
    setPedidos(prev=>prev.filter(p=>p.id!==id));
  };

  const mudarStatus=async(id,status)=>{
    await api.patch('/vendas/pedidos/'+id+'/',{status});
    setPedidos(prev=>prev.map(p=>p.id===id?{...p,status}:p));
  };

  const abrirRetirada=(pedido)=>setModalRetirada(pedido);

  const registrarRetirada=async(dados)=>{
    const res=await api.post('/vendas/pedidos/'+modalRetirada.id+'/registrar_retirada/',dados);
    setModalRetirada(null);
    carregar();
    return res.data;
  };

  return {pedidos,clientes,produtos,loading,salvando,form,itens,modalForm,modalRetirada,
    setF,setItem,selectProduto,addItem,removeItem,carregar,
    abrirNovo,abrirEditar,fecharModal,salvar,excluir,mudarStatus,
    abrirRetirada,registrarRetirada,setModalRetirada};
}
